import { BraidProvider } from 'braid-design-system';
import theme from 'braid-design-system/themes/seekBusiness';
import { ToastProvider } from '../contexts/ToastProvider';
import { LoggerProvider } from '../contexts/LoggerProvider';
import AppRoutes from '../routes';
import { AuthProvider } from '../contexts/AuthProvider';
import { UserPermissionAndMenuProvider } from '../contexts/UserPermissionAndMenuProvider';
import { WebSocketProvider } from '../contexts/WebSocketProvider';
import { config } from '../config/app.config';
import { PageHeadingProvider } from '../contexts/PageHeadingProvider';

// Main App component with providers
export const App = () => {
  return (
    <BraidProvider theme={theme}>
      <LoggerProvider>
        <ToastProvider>
          <AuthProvider>
            <UserPermissionAndMenuProvider>
              <PageHeadingProvider>
                <WebSocketProvider wsUrl={config.wsUrl}>
                  <AppRoutes />
                </WebSocketProvider>
              </PageHeadingProvider>
            </UserPermissionAndMenuProvider>
          </AuthProvider>
        </ToastProvider>
      </LoggerProvider>
    </BraidProvider>
  );
};
